import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MediaTypeService {

  mediaTypes: Record<string,string> = {
    ".3g2": "video/3gpp2",
    ".3gp": "video/3gpp",
    ".7z": "application/x-7z-compressed",
    ".avi": "video/x-msvideo",
    ".bmp": "image/bmp",
    ".bz2": "application/x-bzip2",
    ".doc": "application/msword",
    ".docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ".flv": "video/x-flv",
    ".gif": "image/gif",
    ".gz": "application/gzip",
    ".jpeg": "image/jpeg",
    ".jpg": "image/jpeg",
    ".m4v": "video/x-m4v",
    ".mkv": "video/x-matroska",
    ".mov": "video/quicktime",
    ".mp3": "audio/mpeg",
    ".mp4": "video/mp4",
    ".ogg": "audio/ogg",
    ".pdf": "application/pdf",
    ".png": "image/png",
    ".ppt": "application/vnd.ms-powerpoint",
    ".pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ".rar": "application/x-rar-compressed",
    ".rtf": "application/rtf",
    ".tar": "application/x-tar",
    ".tif": "image/tiff",
    ".tiff": "image/tiff",
    ".txt": "text/plain",
    ".wav": "audio/wav",
    ".webm": "video/webm",
    ".wmv": "video/x-ms-wmv",
    ".xls": "application/vnd.ms-excel",
    ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ".zip": "application/zip"
  }

  getMediaType(fileName: string): string {
    const ext = fileName.substring(fileName.lastIndexOf('.'));
    return this.mediaTypes[ext] || 'application/octet-stream';
  }

  isImageFile(fileName: string): boolean {
    const ext = fileName.substring(fileName.lastIndexOf('.'));
    return ext === '.jpg' || ext === '.jpeg' || ext === '.png' || ext === '.gif' || ext === '.bmp';
  }

  isPdfFile(fileName: string): boolean {
    const ext = fileName.substring(fileName.lastIndexOf('.'));
    return ext === '.pdf';
  }

  isViewable(fileName: string): boolean {
    return (
      this.isImageFile(fileName) ||
      this.isPdfFile(fileName)
    );
  }

}
